import React from 'react';
import Link from 'next/link';

import { useTranslation } from 'next-i18next';

import { Section, Container, Tile, Description } from '@components/Candidate/ImportantSection/styles';
import TextHeader, { SIZE, WEIGHT, TAG } from '@components/TextHeader';

import CandidateTiles from '@constants/CandidateTiles.json';

function ImportantSection() {
  const { t } = useTranslation('candidate');
  return (
    <Section>
      <TextHeader size={SIZE.LG} weight={WEIGHT.NORMAL}>
        {t('Important for the candidate')}
      </TextHeader>
      <Container>
        {CandidateTiles.map((tile, i) => (
          <Link href={tile.link} key={tile.id}>
            <Tile image={tile.image}>
              <TextHeader size={SIZE.MD} weight={WEIGHT.MEDIUM} tag={TAG.H3}>
                {t(`header${i}`)}
              </TextHeader>
              <Description>{t(`description${i}`)}</Description>
            </Tile>
          </Link>
        ))}
      </Container>
    </Section>
  );
}

export default ImportantSection;
